
export interface Size {
  w: number;
  h: number;
}

export interface Crop {
  zoom: number;
  x: number;
  y: number;
}

export const MIN_ZOOM = 1;
export const MAX_ZOOM = 4;

export function scaleOf(natural: Size, view: number, zoom: number): number {
  return (view / Math.min(natural.w, natural.h)) * zoom;
}

export function clampCrop(natural: Size, view: number, crop: Crop): Crop {
  const zoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, crop.zoom));
  const s = scaleOf(natural, view, zoom);
  const minX = view - natural.w * s;
  const minY = view - natural.h * s;
  return {
    zoom,
    x: Math.min(0, Math.max(minX, crop.x)),
    y: Math.min(0, Math.max(minY, crop.y)),
  };
}

export function initialCrop(natural: Size, view: number): Crop {
  const s = scaleOf(natural, view, MIN_ZOOM);
  return clampCrop(natural, view, {
    zoom: MIN_ZOOM,
    x: (view - natural.w * s) / 2,
    y: (view - natural.h * s) / 2,
  });
}

export function zoomAt(
  natural: Size,
  view: number,
  crop: Crop,
  nextZoom: number,
  anchor: { x: number; y: number } = { x: view / 2, y: view / 2 },
): Crop {
  const zoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, nextZoom));
  const ratio = scaleOf(natural, view, zoom) / scaleOf(natural, view, crop.zoom);
  return clampCrop(natural, view, {
    zoom,
    x: anchor.x - (anchor.x - crop.x) * ratio,
    y: anchor.y - (anchor.y - crop.y) * ratio,
  });
}

export function sourceRect(
  natural: Size,
  view: number,
  crop: Crop,
): { sx: number; sy: number; size: number } {
  const s = scaleOf(natural, view, crop.zoom);
  return { sx: 0 - crop.x / s, sy: 0 - crop.y / s, size: view / s };
}
